export function openSocial(url, type) {
    let socials = {
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
        linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=',
        whatsapp: 'https://api.whatsapp.com/send?text=',
    };

    window.open(socials[type] + url, 'popup', 'width=600,height=600');

    return false;
}
